import { useActivation } from '@/hooks/view-model-hooks'
import { observer } from 'mobx-react-lite'
import { Outlet, useParams } from 'react-router'
import { type TeamsViewModel } from '@/features/iam/teams/TeamsViewModel'
import { NewTeamModalContainer } from '@/features/iam/teams/NewTeamModal/NewTeamModalContainer'
import { ContentLoading } from '@/components/ContentLoading'
import { ContentError } from '@/components/ContentError'
import { SplitView, SplitViewMain, SplitViewSide } from '@/components/SplitView'
import { useFeatures } from '@/contexts/root-store-context'
import { Teams } from '@/features/iam/teams/Teams'
import { TeamListContainer } from '@/features/iam/teams/components/TeamList/TeamListContainer'
import { TeamsEmpty } from '@/features/iam/teams/components/TeamsEmpty'

export interface TeamsContainerProps {
  vm: TeamsViewModel
}

export const TeamsContainer = observer(function TeamsContainer({
  vm,
}: TeamsContainerProps) {
  const { teamSlug } = useParams<{ teamSlug?: string }>()
  const { shellInfo } = useFeatures(({ shell }) => ({
    shellInfo: shell.shellInfo,
  }))

  useActivation(vm)

  return (
    <Teams newTeamModal={<NewTeamModalContainer vm={vm.newTeamVm} />}>
      {vm.fetch.match({
        pending: () => <ContentLoading />,
        rejected: (err: unknown) => <ContentError error={err} />,
        resolved: () => (
          <SplitView>
            <SplitViewSide>
              <TeamListContainer
                vm={vm.teamListVm}
                onCreateTeamRequest={vm.newTeamVm.show}
                showCreateAction={vm.canCreateTeam}
                activeTeamSlug={teamSlug}
              />
            </SplitViewSide>
            <SplitViewMain>
              {vm.teams.length === 0 && (
                <TeamsEmpty
                  showCreateActions={vm.canCreateTeam}
                  onCreateTeamRequest={vm.newTeamVm.show}
                  corporateMode={shellInfo.corporateMode}
                />
              )}
              <Outlet context={vm} />
            </SplitViewMain>
          </SplitView>
        ),
      })}
    </Teams>
  )
})
